import React from 'react';
import Confetti from 'react-confetti';
import styles from './index.module.css';

const ConfettiComponent = () => {
    return (
        <Confetti
            width={450}            
            height={420}
            numberOfPieces={100}
            recycle={true}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none',
                zIndex: 2,
            }}
        />
    );
};

export default ConfettiComponent;
